import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";
import PersonaReact from "persona-react";

import { BodyLargeBold, Button, IllustrationManifest, tokens } from "@manifesthhqinc/ui-library";
import * as Styled from "../post-transfer/styles";

import { BodyLargeRegular, HeadlineMedium, BodyMediumRegular } from "../../components/font";
import useTransferTasks from "./useTransferTasks";
import {
  STEP_IDENTITY_VERIFICATION,
  STEP_IDENTITY_VERIFICATION_PERSONA,
  STEP_SPOUSE_NOTARY,
} from "../../class/transferDetails";
import ScrollableContainer from "../../layout/scrollable-container";
import Container from "../../layout/container";
import Flex from "../../layout/flex";
import Footer from "../../components/footer";
import { LoadingContainer } from "../destination-account/screens/styles";

import Spinner from "../../components/spinner";
import { COLOR_MANIFEST_TEAL } from "../../styles/globalStylesVariables";
import { TransferTask } from "../../class/transferTask";
import { SandboxBanner } from "./styles";
import IDVector from "./assets/IDVer.svg";

const TransferTasks = () => {
  const { idTask, currentScreen, showPersona, onFinishPersona, onClickGotIt, isMock, goToNextTask } =
    useTransferTasks();
  if (currentScreen === STEP_IDENTITY_VERIFICATION) {
    return (
      <TransitionWrapper>
        <ScrollableContainer name="id-verification-start">
          <Container>
            <Flex $flexGap={8} $flexDirection="column">
              <HeadlineMedium $textAlign="center">We need to verify your identity for your annuity</HeadlineMedium>
              <BodyLargeRegular $textAlign="center" $color={tokens.color.text.secondary}>
                We’ll securely verify your identity using a valid ID. This should only take a few minutes.
              </BodyLargeRegular>
            </Flex>
            <Styled.VectorWrapper>
              <img src={IDVector} alt="id-verification" />
            </Styled.VectorWrapper>
            {/* <p className="form-description pr-20 pl-20" style={{ marginBottom: 0 }}></p> */}
          </Container>
        </ScrollableContainer>
        <Footer>
          <Button name="start-id-verification" onClick={showPersona} size="large">
            Continue
          </Button>
        </Footer>
      </TransitionWrapper>
    );
  }
  if (currentScreen === STEP_IDENTITY_VERIFICATION_PERSONA) {
    if (isMock) {
      return (
        <TransitionWrapper>
          <ScrollableContainer name="id-verification-start">
            <Container>
              <Flex $flexGap={8} $flexDirection="column">
                <HeadlineMedium $textAlign="center">Identity Verification</HeadlineMedium>
              </Flex>

              <SandboxBanner>
                <BodyLargeBold>
                  You are in Sandbox environment. <br />
                  Status will not persist
                </BodyLargeBold>
              </SandboxBanner>
            </Container>
          </ScrollableContainer>
          <Footer>
            <Button name="start-id-verification" onClick={goToNextTask} size="large">
              Continue
            </Button>
          </Footer>
        </TransitionWrapper>
      );
    }
    if ((idTask as TransferTask).identityVerification) {
      return (
        <PersonaReact
          inquiryId={(idTask as TransferTask).identityVerification?.personaInquiryId}
          frameAncestors={[
            "https://dev-bridge.dev-manifest.com", // our app
            "https://bridge.usemanifest.com",
          ]}
          onError={(e) => console.error("on Error", e)} // TODO: do something
          onComplete={({ status }) => {
            onFinishPersona(status);
          }}
        />
      );
    }
  }

  if (currentScreen === STEP_SPOUSE_NOTARY) {
    return (
      <TransitionWrapper>
        <ScrollableContainer name="phone-call-needed-screen">
          <Container>
            <Flex $flexGap={8} $flexDirection="column">
              <HeadlineMedium $textAlign="center">
                Lastly, it’s common for an annuity to require spousal consent
              </HeadlineMedium>
              <BodyMediumRegular $textAlign="center">
                We’ll send your spouse a secure email with simple steps to sign through an online notary.
              </BodyMediumRegular>
            </Flex>
            <Styled.VectorWrapper>
              <IllustrationManifest width={200} />
            </Styled.VectorWrapper>
          </Container>
        </ScrollableContainer>
        <Footer>
          <BodyMediumRegular $color={tokens.color.text.secondary} $textAlign="center">
            No action needed on your end – we've got everything covered!
          </BodyMediumRegular>
          <Button name="continue" onClick={onClickGotIt} size="large">
            Got it!
          </Button>
        </Footer>
      </TransitionWrapper>
    );
  }

  return (
    <>
      <LoadingContainer>
        <Styled.PhoneCallLoadingScreen>
          <Spinner size={35} color={COLOR_MANIFEST_TEAL} />
        </Styled.PhoneCallLoadingScreen>
      </LoadingContainer>
    </>
  );
};

export default TransferTasks;
